import { isReverseShareSumValid } from '../scenarios/validation';

export interface MergeEdgeShare {
  edgeId: string;
  reverseShare?: number;
}

export interface ReverseMergeResolution {
  /** false when the merge is ambiguous (SIM-REQ-007) — no share was assumed. */
  resolved: boolean;
  shares: Map<string, number>;
}

/**
 * SPEC-009 §31-33/plan §22/SIM-REQ-007/008 — a node with multiple incoming
 * edges has no implicit allocation. Only resolves when every incoming edge
 * has an explicit `reverseShare` and they sum to 1 (tolerance for decimal
 * precision); otherwise reports ambiguous rather than guessing.
 */
export function resolveReverseMergeShares(edges: readonly MergeEdgeShare[]): ReverseMergeResolution {
  if (edges.length <= 1) {
    const shares = new Map<string, number>();
    if (edges.length === 1) shares.set(edges[0]!.edgeId, edges[0]!.reverseShare ?? 1);
    return { resolved: true, shares };
  }

  const allHaveShares = edges.every((edge) => typeof edge.reverseShare === 'number');
  if (!allHaveShares) return { resolved: false, shares: new Map() };

  const values = edges.map((edge) => edge.reverseShare!);
  if (!isReverseShareSumValid(values)) return { resolved: false, shares: new Map() };

  const shares = new Map(edges.map((edge) => [edge.edgeId, edge.reverseShare!]));
  return { resolved: true, shares };
}
